export default __webpack_public_path__ + "static/media/logo-dark.124c2302.svg";